import customerimportjobService from "../services/customerimportjob.service";
const customerimportjobs = {
    namespaced: true,
    state: {},
    actions: {
        //CREATE
        create(_, formData) {
            return customerimportjobService.create(formData);
        },
        reset(_, formData) {
            return customerimportjobService.reset(formData);
        },
        sendWhatsAppToNewCustomers(_, id) {
            return customerimportjobService.sendWhatsAppToNewCustomers(id);
        },
        //READ
        get(_, params) {
            return customerimportjobService.get(
                params.id,
                params.urlParameters,
                params.requestId
            );
        },
    },
    getters: {},
    mutations: {},
};

export default customerimportjobs;
